export enum EmailActionsEnum {
  Validate = 'validate',
  Reply = 'reply',
  ReplyAll = 'replyAll',
  Forward = 'forward',
  Reassign = 'reassign',
  MoveToFolder = 'moveToFolder',
  MoveToDraft = 'moveToDraft',
  Groups = 'groups',
  Archive = 'archive',
  Tags = 'tags',
  Audit = 'audit',
  SetRead = 'setRead',
  SetUnread = 'setUnread',
  RetrySending = 'retrySending',
  MarkAsSpam = 'markAsSpam',
  MarkAsNotSpam = 'markAsNotSpam',
  Restore = 'restore',
  RestoreArchive = 'restoreArchive',
  Delete = 'delete',
  DeleteFinalMail = 'deleteFinalMail',
  DownloadSingleEml = 'downloadSingleEml',
  DownloadEml = 'downloadEml',
  Meta = 'meta',
  Archiving = 'archiving',
}
